import { DATE_FORMATTER_STR, formatDate } from "best-common-react";
import React, { memo, useMemo } from "react";
import { GamePreviewDTO } from "../../../types/Game";
import { TicketRequestDTO } from "../../../types/TicketRequest";
import AdminRequestGame from "./AdminRequestGame";

type AdminRequestsViewProps = {
  schedule: number[];
  games: { [key: number]: GamePreviewDTO };
  requests: { [key: number]: TicketRequestDTO[] };
  startDate: string;
  jumpToRequestId?: number;
};

const AdminRequestsView = memo(
  ({ schedule = [], games, requests, startDate, jumpToRequestId }: AdminRequestsViewProps) => {
    const startDateKey = useMemo(() => formatDate(startDate, DATE_FORMATTER_STR), [startDate]);

    return (
      <>
        {schedule.map((gamePk: number) => {
          const game = games[gamePk];
          const gameDateKey = game?.gameDate ? formatDate(game.gameDate, DATE_FORMATTER_STR) : undefined;

          return (
            <AdminRequestGame
              key={gamePk}
              game={game}
              requests={requests[gamePk]}
              showRequestCountInHeader
              startOpen={gameDateKey === startDateKey}
              jumpToRequestId={jumpToRequestId}
            />
          );
        })}
      </>
    );
  },
);

export default AdminRequestsView;
